import React from 'react';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { NPI } from '../components/NPI';
import { Name } from '../components/Name';
import { State } from '../components/State';
import { City } from '../components/City';
import { TaxID } from '../components/TaxID';
import { ZipCode } from '../components/ZipCode';
import { Radius } from '../components/Radius';
import { OrganizationalType } from '../components/OrganizationalType';

export const FacilityForm = () => {
  const { searchBy } = usePropsContext();

  return (
    <React.Fragment>
      <If condition={searchBy === 'npi'}>
        <NPI />
      </If>
      <If condition={searchBy === 'name_state'}>
        <Name />
        <State />
      </If>
      <If condition={searchBy === 'state_city'}>
        <State />
        <City />
      </If>
      <If condition={searchBy === 'tax_id_number'}>
        <TaxID />
      </If>
      <If condition={searchBy === 'zip_code'}>
        <ZipCode />
        <Radius />
        <OrganizationalType />
      </If>
    </React.Fragment>
  );
};
